import './style.less';
import { get } from 'lodash';

export default function($log, $q, $state, $stateParams, ResolveClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.stateParams = $stateParams;
  vm.returnRoute = false;
  vm.uid = $stateParams.id;
  vm.question = {
    bol: true
  };

  vm.emailAddress = get(ProfileClass, 'profile_complete.company.preferences.certificates.emailAddress', false);

  vm.checkRoute = function(route) {
    return ResolveClass.isAllowedCompanyRoute(route);
  };

  function activate() {
    $log.debug('Users Certificate Upload Activated');

    try {
      vm.error = {};
      vm.loaded = true;
    } catch (error) {
      $log.error(error);
      vm.loaded = true;
      vm.error = {
        status: true,
        refresh: activate
      };
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/certificates/put/index.js